import * as angular from "angular";

export class ShippersRequestsService {

  /* @ngInject */
  constructor(private ShippersAPI, private $shippers) {
  }

  updatePassword(shipperId, password) {
    const api = this.ShippersAPI.actions.updatePassword;
    return this.$$call(api, {}, {password: password}, {id: shipperId});
  }

  deleteShipper(shipperId, shouldMask) {
    const api = this.ShippersAPI.actions.deleteShipper;
    return this.$$call(api, {mask: shouldMask}, {}, {id: shipperId});
  }

  addShipperApi(shipper: { displayName: string, accountId: string }) {
    const api = this.ShippersAPI.actions.addShipperApi;
    return this.$$call(api, {}, shipper, {});
  }

  // ******************************
  // Internal methods
  // ******************************

  $$call(_apiCall, _params, _data, _options) {
    return this.$shippers().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.shippers')
  .service('shippersRequestsService', ShippersRequestsService);
